export const getFutureDate = (days) => {
	try {
		const today = new Date();
		today.setDate(today.getDate() + days + 1);
		return today;
	} catch (e) {
		return new Date();
	}
};
